module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/venue-template-editor/venue-template-editor.component.scss
// module id = ./src/app/modules/common-module/components/venue-template-editor/venue-template-editor.component.scss
// module chunks = 9